import script from "./PartOne.vue?vue&type=script&setup=true&lang=js"
export * from "./PartOne.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__